import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

const List = (props) => {
  const [animate, setAnimate] = useState(props.isLoading);
  const loadingClassNames = ["opacity-25", "opacity-50", "opacity-75", "opacity-50", "opacity-25"];
  const delay = 0.25;

  useEffect(() => {
    setAnimate(props.isLoading);
  }, [props.isLoading]);

  return (
    <ul
      className={`list-description ${props.classNames || ""}`}
      style={animate === true ? { animation: "fade-in 2.5s ease-in" } : { animation: "fade-in .5s ease-in" }}
    >
      {animate === true ? (
        <>
          {loadingClassNames.map((item, index) => (
            <li
              className={`${item} animating`}
              style={{
                animationDelay: `${delay * index}s`,
                backgroundColor: "#d07c3b",
              }}
              key={uuidv4()}
            ></li>
          ))}
        </>
      ) : (
        props.children
      )}
    </ul>
  );
};

export default List;
